"use client";

import { createContext, useContext, useState, useEffect } from 'react';

// Create a theme context
const ThemeContext = createContext({
  theme: 'light',
  toggleTheme: () => {},
});

// Theme provider component
export function ThemeProvider({ children }) {
  // Default to light theme, but check localStorage on client
  const [theme, setTheme] = useState('light');

  // Load theme preference from localStorage on client side
  useEffect(() => {
    const savedTheme = localStorage.getItem('openMenuTheme');
    if (savedTheme) {
      setTheme(savedTheme);
      // Apply theme to body
      document.body.classList.toggle('dark-theme', savedTheme === 'dark');
    }
  }, []);

  // Toggle between light and dark themes
  const toggleTheme = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light';
    setTheme(newTheme);
    localStorage.setItem('openMenuTheme', newTheme);
    // Apply theme to body
    document.body.classList.toggle('dark-theme', newTheme === 'dark');
  };

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

// Custom hook to use the theme context
export function useTheme() {
  return useContext(ThemeContext);
} 